import PackagesList from "../../components/Packages/PackagesList";

const packagesRoutes = [
    {
        path: '',
        name: 'Packages',
        component: PackagesList,
        meta: { title: 'Packages', resource: 'packages', action: 'view'},
    },
];

export default packagesRoutes;
